import React, { useState, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "./firebase";
import "./LocationLabel.css";

// Hardcoded tooltips (static)
const tooltips = [
  { name: "Internal Road", coords: "project6BaseCoords", className: "project-8-label", transform: "translate(-50%, -100%)", isBold: true },
  { name: "🛣️ Kanakapura Main Road 3.5KM", coords: "c3", className: "project-5-label" },
  { name: "🛣️ Towards Sathanur", coords: "c10", className: "project-5-label" },
  { name: "🌉 Bridge 1", coords: "c8", className: "project-5-label" },
  { name: "⛩️ Entrance", coords: "c9", className: "project-5-label" },
  { name: "🏡", coords: "c5", className: "i-label" },
];

// Hardcoded plots (hover labels for desktop only)
const plots = [
    { name: "Plot 1", x: 1802, y: 2764, dataKey: "plot-1" },
  { name: "Plot 2", x: 1915, y: 2750, dataKey: "plot-2" },
  { name: "Plot 3", x: 2130, y: 2703, dataKey: "plot-3" },
  { name: "Plot 4", x: 2342, y: 2674, dataKey: "plot-4" },
  { name: "Plot 5", x: 2544, y: 2646, dataKey: "plot-5" },
  { name: "Plot 6", x: 2671, y: 2632, dataKey: "plot-6" },
  { name: "Plot 7", x: 2839, y: 2605, dataKey: "plot-7" },
  { name: "Plot 8", x: 1821, y: 2960, dataKey: "plot-8" },
  { name: "Plot 9", x: 1947, y: 2945, dataKey: "plot-9" },
  { name: "Plot 10", x: 2158, y: 2919, dataKey: "plot-10" },
  { name: "Plot 11", x: 2378, y: 2888, dataKey: "plot-11" },
  { name: "Plot 12", x: 2592, y: 2859, dataKey: "plot-12" },
  { name: "Plot 13", x: 2704, y: 2841, dataKey: "plot-13" },
  { name: "Plot 14", x: 2894, y: 2816, dataKey: "plot-14" },
  { name: "Plot 15", x: 2174, y: 3157, dataKey: "plot-15" },
  { name: "Plot 16", x: 2000, y: 3173, dataKey: "plot-16" },
  { name: "Plot 17", x: 1843, y: 3191, dataKey: "plot-17" },
  { name: "Plot 18", x: 1864, y: 3393, dataKey: "plot-18" },
  { name: "Plot 19", x: 2016, y: 3379, dataKey: "plot-19" },
  { name: "Plot 20", x: 2193, y: 3368, dataKey: "plot-20" },
  { name: "Plot 21", x: 2452, y: 3321, dataKey: "plot-21" },
  { name: "Plot 22", x: 2641, y: 3309, dataKey: "plot-22" },
  { name: "Plot 23", x: 2806, y: 3296, dataKey: "plot-23" },
  { name: "Plot 24", x: 2976, y: 3286, dataKey: "plot-24" },
  { name: "Plot 25", x: 2031, y: 2547, dataKey: "plot-25" },
  { name: "Plot 26", x: 2004, y: 2389, dataKey: "plot-26" },
  { name: "Plot 27", x: 1983, y: 2251, dataKey: "plot-27" },
  { name: "Plot 28", x: 1964, y: 2134, dataKey: "plot-28" },
  { name: "Plot 29", x: 1940, y: 2000, dataKey: "plot-29" },
  { name: "Plot 30", x: 1916, y: 1865, dataKey: "plot-30" },
  { name: "Plot 31", x: 1898, y: 1737, dataKey: "plot-31" },
  { name: "Plot 32", x: 2205, y: 1693, dataKey: "plot-32" },
  { name: "Plot 33", x: 2221, y: 1823, dataKey: "plot-33" },
  { name: "Plot 34", x: 2241, y: 1960, dataKey: "plot-34" },
  { name: "Plot 35", x: 2259, y: 2095, dataKey: "plot-35" },
  { name: "Plot 36", x: 2276, y: 2232, dataKey: "plot-36" },
  { name: "Plot 37", x: 2299, y: 2371, dataKey: "plot-37" },
  { name: "Plot 38", x: 2315, y: 2508, dataKey: "plot-38" },
  { name: "Plot 39", x: 2476, y: 1928, dataKey: "plot-39" },
  { name: "Plot 40", x: 2489, y: 2068, dataKey: "plot-40" },
  { name: "Plot 41", x: 2514, y: 2219, dataKey: "plot-41" },
  { name: "Plot 42", x: 2531, y: 2358, dataKey: "plot-42" },
  { name: "Plot 43", x: 2553, y: 2510, dataKey: "plot-43" },
  { name: "Plot 44", x: 2807, y: 1931, dataKey: "plot-44" },
  { name: "Plot 45", x: 2830, y: 2065, dataKey: "plot-45" },
  { name: "Plot 46", x: 2853, y: 2199, dataKey: "plot-46" },
  { name: "Plot 47", x: 2878, y: 2340, dataKey: "plot-47" },
  { name: "Plot 48", x: 2900, y: 2466, dataKey: "plot-48" },
  { name: "Plot 49", x: 2840, y: 3087, dataKey: "plot-49" }
];

// Hardcoded plot centers
const plotCenters = [
 
];

const LocationLabels = ({ labelStyle, getResponsivePosition, coords, hoveredPlotId, onC5Click, onC7Click }) => {
  const [plotStatuses, setPlotStatuses] = useState({});
  const [loading, setLoading] = useState(true);
  const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;

  // Hover highlight is now driven by the SVG overlay in Map.jsx via hoveredPlotId.
  const hoveredPlot = plots.find((p) => p.dataKey === hoveredPlotId) || null;

  useEffect(() => {
    const fetchPlotStatuses = async () => {
      try {
        const plotsCollection = collection(db, "plots");
        const plotsSnapshot = await getDocs(plotsCollection);
        const statusMap = plotsSnapshot.docs.reduce((acc, doc) => {
          const data = doc.data();
          acc[doc.id] = data.Status || "Unknown";
          return acc;
        }, {});
        setPlotStatuses(statusMap);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching plot statuses from Firestore:", error);
        setPlotStatuses({});
        setLoading(false);
      }
    };

    fetchPlotStatuses();
  }, []);

  if (loading) {
    return null; // Render nothing while loading
  }

  return (
    <>
      {tooltips.map((tooltip, index) => {
        const coord = coords[tooltip.coords];
        if (!coord) return null;

        return (
          <div
            key={`tooltip-${index}`}
            className={`persistent-tooltip ${tooltip.className}`}
            onClick={(e) => {
              e.stopPropagation();
              if (tooltip.coords === "c5" && onC5Click) onC5Click();
              else if (tooltip.coords === "c7" && onC7Click) onC7Click();
            }}
            style={{
              ...labelStyle,
              ...getResponsivePosition(coord.x, coord.y),
              transform: tooltip.transform || "none",
              border: tooltip.border || "none",
              cursor: tooltip.coords === "c5" || tooltip.coords === "c7" ? "pointer" : "default",
            }}
          >
            {tooltip.isBold ? (
              <strong>
                {tooltip.name}
                {tooltip.description && <span dangerouslySetInnerHTML={{ __html: tooltip.description }} />}
              </strong>
            ) : (
              <>
                {tooltip.name}
                {tooltip.description && <span dangerouslySetInnerHTML={{ __html: tooltip.description }} />}
              </>
            )}
          </div>
        );
      })}

      {!loading &&
        plotCenters.map((plot, index) => {
          const status = plotStatuses[plot.id] || "Unknown";
          if (status === "Available") return null;

          let backgroundColor;
          if (status === "Sold") backgroundColor = "red";
          else if (status === "Booked") backgroundColor = "orange";
          else backgroundColor = "rgba(36, 35, 35, 0.8)";

          return (
            <div
              key={`plot-center-${index}`}
              className="plot-center-label"
              style={{
                ...labelStyle,
                ...getResponsivePosition(plot.x, plot.y),
                transform: "translate(-50%, -50%)",
                fontSize: "4px",
                color: "White",
                backgroundColor: backgroundColor,
                padding: "2px",
                borderRadius: "1px"
              }}
            >
              {`${plot.alt}`}
              <br />
              {`${status}`}
            </div>
          );
        })}

      {!isTouchDevice && hoveredPlot && (
        <div
          className="plot-hover-label"
          style={{
            ...labelStyle,
            ...getResponsivePosition(hoveredPlot.x, hoveredPlot.y),
            transform: "translate(-50%, -50%)",
          }}
        >
          {hoveredPlot.name}
        </div>
      )}
    </>
  );
};

export default LocationLabels;




